module.exports = __webpack_public_path__ + "static/media/email-color.3f6c4c01.png";